export default __webpack_public_path__ + "static/media/Wednesday_07.36cee63a.png";